<template>
  <div class="dk-integracoes-wrap">

    <!-- ── TABELA DE INTEGRAÇÕES ATIVAS ─────────────────────── -->
    <div
      class="dk-int-card mb-4"
      data-tourTarget="list-integrations-chat"
    >
      <div class="dk-int-header">
        <div class="dk-int-header-left">
          <feather-icon icon="ZapIcon" size="18" class="dk-int-header-icon" />
          <span class="dk-int-header-title">Integrações ativas</span>
          <span class="dk-int-count-badge">{{ rdStationIntegraions.length }}</span>
        </div>
      </div>

      <div v-if="rdStationIntegraions.length === 0" class="dk-empty-state">
        <feather-icon icon="LinkIcon" size="40" class="dk-empty-icon" />
        <p class="dk-empty-text">Nenhuma integração configurada ainda.</p>
        <p class="dk-empty-sub">Adicione uma integração abaixo para começar.</p>
      </div>

      <div v-else class="dk-table-wrap">
        <table class="dk-table">
          <thead>
            <tr>
              <th>Ativo</th>
              <th>Plataforma</th>
              <th>Identificador</th>
              <th>Fluxo</th>
              <th>Evento</th>
              <th>Criado em</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in rdStationIntegraions"
              :key="item.id"
              class="dk-table-row"
            >
              <td>
                <div data-tourTarget="check-button-status-integration">
                  <b-form-checkbox
                    v-model="item.status"
                    :name="`check-button-status-integration-${item.id}`"
                    switch
                    inline
                    class="dk-status-switch"
                    @change="changeStatusIntegration(item.id, item.status)"
                  />
                </div>
              </td>
              <td>
                <span class="dk-model-badge" :class="`dk-model-${item.modelo ? item.modelo.toLowerCase().replace(/\s/g,'') : 'default'}`">
                  {{ item.modelo }}
                </span>
              </td>
              <td>
                <span class="dk-identifier">{{ item.indetificador }}</span>
              </td>
              <td>
                <span class="dk-flow-name">{{ item.NOME }}</span>
              </td>
              <td>
                <span class="dk-event-badge">{{ item.eventos }}</span>
              </td>
              <td>
                <span class="dk-date">{{ item.criado_em }}</span>
              </td>
              <td>
                <div class="dk-actions">
                  <button
                    v-b-tooltip.hover.top="'Excluir integração'"
                    class="dk-action-btn dk-action-delete"
                    data-tourTarget="delete-integration"
                    @click="showModalDelete(item)"
                  >
                    <feather-icon icon="Trash2Icon" size="14" />
                  </button>
                  <button
                    v-b-tooltip.hover.top="'Editar integração'"
                    class="dk-action-btn dk-action-edit"
                    data-tourTarget="edit-integration"
                    @click="editarIntegracao(item)"
                  >
                    <feather-icon icon="EditIcon" size="14" />
                  </button>
                  <button
                    v-b-tooltip.hover.top="'Enviar teste'"
                    class="dk-action-btn dk-action-test"
                    @click="enviarTesteIntegracao(item)"
                  >
                    <feather-icon icon="SendIcon" size="14" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ── ADICIONAR NOVA INTEGRAÇÃO ─────────────────────────── -->
    <div
      class="dk-int-card"
      data-tourTarget="add-integration"
    >
      <div class="dk-int-header">
        <div class="dk-int-header-left">
          <feather-icon icon="PlusCircleIcon" size="18" class="dk-int-header-icon" />
          <span class="dk-int-header-title">Adicionar nova integração</span>
        </div>
      </div>
      <div class="dk-int-card-body">
        <p class="dk-section-desc">Conecte o chat às suas plataformas de marketing e CRM para automatizar o fluxo de leads.</p>
        <div class="dk-platforms-grid">

          <div class="dk-platform-card">
            <div class="dk-platform-logo-wrap">
              <img src="https://cdn.neurologic.com.br/dashboard/integrations/rdstation.png" alt="RD Station" class="dk-platform-logo">
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">RD Station</h6>
              <p class="dk-platform-desc">Gerencie leads e automações de marketing diretamente no RD Station.</p>
            </div>
            <button class="dk-platform-btn" @click="getUrlAuth">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card">
            <div class="dk-platform-logo-wrap">
              <img src="https://dkplayer.s3.sa-east-1.amazonaws.com/Paulo_Henrique-Id344/imgs/629f0f202979a609419344e1.png" alt="Pipedrive" class="dk-platform-logo">
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">Pipedrive</h6>
              <p class="dk-platform-desc">Sincronize leads do chat direto no seu pipeline de vendas no Pipedrive.</p>
            </div>
            <button class="dk-platform-btn" @click="getUrlAuthPipedrive">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card">
            <div class="dk-platform-logo-wrap">
              <img src="https://dkplayer.s3.sa-east-1.amazonaws.com/logo_Vsl-Booster/ActiveCampaign.png" alt="ActiveCampaign" class="dk-platform-logo">
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">ActiveCampaign</h6>
              <p class="dk-platform-desc">Automatize e-mail marketing enviando leads para o ActiveCampaign.</p>
            </div>
            <button class="dk-platform-btn" @click="getUrlAuthActiveCampaign">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card">
            <div class="dk-platform-logo-wrap">
              <img src="https://cdn.neurologic.com.br/dashboard/integrations/webhook.png" alt="Webhook" class="dk-platform-logo">
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">Webhook</h6>
              <p class="dk-platform-desc">Envie dados de leads para qualquer URL via HTTP POST em tempo real.</p>
            </div>
            <button class="dk-platform-btn" @click="openModalWebhook">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card">
            <div class="dk-platform-logo-wrap">
              <img src="https://chat-booster.s3.amazonaws.com/img/logo_chat_gpt.webp" alt="ChatGPT" class="dk-platform-logo">
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">Chat GPT</h6>
              <p class="dk-platform-desc">Adicione inteligência artificial ao seu chat com a API do ChatGPT.</p>
            </div>
            <button class="dk-platform-btn" @click="openModalGPT">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card">
            <div class="dk-platform-logo-wrap">
              <img src="https://images.ctfassets.net/co0pvta7hzrh/6XPHfHOh41ZNDOUpfPqnMJ/6586c3e725805cc3a802b350d0767e16/463bb5c3f876-Favicon.svg" alt="NoCRM" class="dk-platform-logo">
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">NoCRM</h6>
              <p class="dk-platform-desc">Mantenha seus leads organizados e acompanhe cada oportunidade no NoCRM.</p>
            </div>
            <button class="dk-platform-btn" @click="openModalNoCRM">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card dk-platform-card--highlight">
            <div class="dk-platform-logo-wrap dk-platform-logo-wrap--iaqfaz">
              <feather-icon icon="ZapIcon" size="22" />
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">iAqFaz</h6>
              <p class="dk-platform-desc">Automação de processos e notificações via webhook com o iAqFaz.</p>
            </div>
            <button class="dk-platform-btn" @click="openModalIaqfaz">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card dk-platform-card--highlight">
            <div class="dk-platform-logo-wrap dk-platform-logo-wrap--adsmetrics">
              <feather-icon icon="BarChart2Icon" size="22" />
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">Ads Metrics</h6>
              <p class="dk-platform-desc">Rastreie conversões e métricas de anúncios com eventos automáticos.</p>
            </div>
            <button class="dk-platform-btn dk-platform-btn--ads" @click="openModalAdsMetrics">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card dk-platform-card--highlight">
            <div class="dk-platform-logo-wrap dk-platform-logo-wrap--adsmetrics">
              <feather-icon icon="TargetIcon" size="22" />
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">Meta Offline</h6>
              <p class="dk-platform-desc">Receba vendas e dispare eventos de conversão offline no Meta CAPI.</p>
            </div>
            <button class="dk-platform-btn dk-platform-btn--ads" @click="openModalMetaOffline">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card dk-platform-card--highlight">
            <div class="dk-platform-logo-wrap dk-platform-logo-wrap--adsmetrics">
              <feather-icon icon="TrendingUpIcon" size="22" />
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">Google Ads Offline</h6>
              <p class="dk-platform-desc">Envie conversões com `gclid`, `gbraid` e `wbraid` automaticamente.</p>
            </div>
            <button class="dk-platform-btn dk-platform-btn--ads" @click="openModalGoogleOffline">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Conectar
            </button>
          </div>

          <div class="dk-platform-card dk-platform-card--highlight">
            <div class="dk-platform-logo-wrap dk-platform-logo-wrap--adsmetrics">
              <feather-icon icon="ShieldIcon" size="22" />
            </div>
            <div class="dk-platform-info">
              <h6 class="dk-platform-name">Webhook de Vendas</h6>
              <p class="dk-platform-desc">Crie URL segura com token para receber compras da Kiwify/Hotmart/Eduzz.</p>
            </div>
            <button class="dk-platform-btn dk-platform-btn--ads" @click="openModalInboundWebhook">
              <feather-icon icon="LinkIcon" size="13" class="mr-50" />
              Configurar
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- ── MODAL: Confirmar exclusão ──────────────────────────── -->
    <ModalConfirmation
      title="Excluir integração"
      id-modal="integracao"
      @okDeleteFluxoChat="handleDelete"
    >
      <template #content-message>
        Tem certeza de que deseja <strong>excluir</strong> essa integração? Esta ação não pode ser desfeita.
      </template>
    </ModalConfirmation>

    <!-- ── MODAL: Criar Webhook ──────────────────────────────── -->
    <b-modal
      id="modal-webhook"
      centered
      hide-header
      hide-footer
      size="md"
      @ok="salvarIntegracao()"
    >
      <div class="dk-modal-inner">
        <div class="dk-modal-header">
          <div class="dk-modal-header-left">
            <img src="https://cdn.neurologic.com.br/dashboard/integrations/webhook.png" alt="Webhook" class="dk-modal-logo">
            <div>
              <h5 class="dk-modal-title">Nova integração Webhook</h5>
              <p class="dk-modal-sub">Envio de dados via HTTP POST</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="LinkIcon" size="13" class="mr-1" />URL de destino</label>
            <b-form-input v-model="url" type="text" placeholder="https://sua-url.com/webhook" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GitBranchIcon" size="13" class="mr-1" />Fluxo monitorado</label>
            <select v-model="fluxoSelected" class="dk-mselect">
              <option value="">Selecione um fluxo...</option>
              <option v-for="fluxo in chatsExistents" :key="fluxo.id" :value="fluxo">{{ fluxo.name }}</option>
            </select>
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('modal-webhook')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarIntegracao(); $bvModal.hide('modal-webhook')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar integração
          </button>
        </div>
      </div>
    </b-modal>

    <!-- ── MODAL: Editar Webhook ─────────────────────────────── -->
    <b-modal
      id="edit-modal-webhook"
      centered
      hide-header
      hide-footer
      size="md"
    >
      <div class="dk-modal-inner">
        <div class="dk-modal-header">
          <div class="dk-modal-header-left">
            <img src="https://cdn.neurologic.com.br/dashboard/integrations/webhook.png" alt="Webhook" class="dk-modal-logo">
            <div>
              <h5 class="dk-modal-title">Editar integração Webhook</h5>
              <p class="dk-modal-sub">Atualize os dados de envio</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="LinkIcon" size="13" class="mr-1" />URL de destino</label>
            <b-form-input v-model="inteSelected.url" type="text" placeholder="https://sua-url.com/webhook" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GitBranchIcon" size="13" class="mr-1" />Fluxo monitorado</label>
            <select v-model="inteSelected.id_chat" class="dk-mselect">
              <option value="">Selecione um fluxo...</option>
              <option v-for="fluxo in chatsExistents" :key="fluxo.id" :value="fluxo.id">{{ fluxo.name }}</option>
            </select>
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('edit-modal-webhook')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarEdicaoIntegracao(); $bvModal.hide('edit-modal-webhook')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar alterações
          </button>
        </div>
      </div>
    </b-modal>

    <!-- ── MODAL: Criar Chat GPT ─────────────────────────────── -->
    <b-modal
      id="modal-gpt"
      centered
      hide-header
      hide-footer
      size="md"
    >
      <div class="dk-modal-inner">
        <div class="dk-modal-header">
          <div class="dk-modal-header-left">
            <img src="https://chat-booster.s3.amazonaws.com/img/logo_chat_gpt.webp" alt="ChatGPT" class="dk-modal-logo">
            <div>
              <h5 class="dk-modal-title">Nova integração Chat GPT</h5>
              <p class="dk-modal-sub">Inteligência artificial no seu chat</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="KeyIcon" size="13" class="mr-1" />API Token</label>
            <b-form-input v-model="apiToken" type="text" placeholder="sk-..." class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="MessageSquareIcon" size="13" class="mr-1" />Contexto (system prompt)</label>
            <b-form-input v-model="contexto" type="text" placeholder="Você é um assistente de vendas..." class="dk-minput" />
          </div>
          <div class="dk-mrow2">
            <div class="dk-mfield">
              <label class="dk-mlabel"><feather-icon icon="ThermometerIcon" size="13" class="mr-1" />Temperatura</label>
              <b-form-input v-model="temperatura" type="number" placeholder="0.8" class="dk-minput" />
            </div>
            <div class="dk-mfield">
              <label class="dk-mlabel"><feather-icon icon="HashIcon" size="13" class="mr-1" />Max Tokens</label>
              <b-form-input v-model="max_tokens" type="number" placeholder="250" class="dk-minput" />
            </div>
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GitBranchIcon" size="13" class="mr-1" />Fluxo monitorado</label>
            <select v-model="fluxoSelected" class="dk-mselect">
              <option value="">Selecione um fluxo...</option>
              <option v-for="fluxo in chatsExistents" :key="fluxo.id" :value="fluxo">{{ fluxo.name }}</option>
            </select>
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('modal-gpt')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarIntegracaoGPT(); $bvModal.hide('modal-gpt')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar integração
          </button>
        </div>
      </div>
    </b-modal>

    <!-- ── MODAL: Criar NoCRM ─────────────────────────────────── -->
    <b-modal
      id="modal-nocrm"
      centered
      hide-header
      hide-footer
      size="md"
    >
      <div class="dk-modal-inner">
        <div class="dk-modal-header">
          <div class="dk-modal-header-left">
            <img src="https://images.ctfassets.net/co0pvta7hzrh/6XPHfHOh41ZNDOUpfPqnMJ/6586c3e725805cc3a802b350d0767e16/463bb5c3f876-Favicon.svg" alt="NoCRM" class="dk-modal-logo">
            <div>
              <h5 class="dk-modal-title">Nova integração NoCRM</h5>
              <p class="dk-modal-sub">Organize leads no seu CRM</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="KeyIcon" size="13" class="mr-1" />API Token</label>
            <b-form-input v-model="apiToken" type="text" placeholder="Digite o token" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GlobeIcon" size="13" class="mr-1" />Endereço de conta</label>
            <b-form-input v-model="url" type="text" placeholder="https://SUBDOMINIO.nocrm.io" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GitBranchIcon" size="13" class="mr-1" />Fluxo monitorado</label>
            <select v-model="fluxoSelected" class="dk-mselect">
              <option value="">Selecione um fluxo...</option>
              <option v-for="fluxo in chatsExistents" :key="fluxo.id" :value="fluxo">{{ fluxo.name }}</option>
            </select>
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('modal-nocrm')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarIntegracaoNoCRM(); $bvModal.hide('modal-nocrm')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar integração
          </button>
        </div>
      </div>
    </b-modal>
    <!-- ── MODAL: Editar Chat GPT ───────────────────────────── -->
    <b-modal
      id="edit-modal-gpt"
      centered
      hide-header
      hide-footer
      size="md"
    >
      <div class="dk-modal-inner">
        <div class="dk-modal-header">
          <div class="dk-modal-header-left">
            <img src="https://chat-booster.s3.amazonaws.com/img/logo_chat_gpt.webp" alt="ChatGPT" class="dk-modal-logo">
            <div>
              <h5 class="dk-modal-title">Editar integração Chat GPT</h5>
              <p class="dk-modal-sub">Atualize as configurações de IA</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="KeyIcon" size="13" class="mr-1" />API Token</label>
            <b-form-input v-model="inteSelected.api_token" type="text" placeholder="sk-..." class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="MessageSquareIcon" size="13" class="mr-1" />Contexto (system prompt)</label>
            <b-form-input v-model="inteSelected.context_gpt" type="text" placeholder="Você é um assistente de vendas..." class="dk-minput" />
          </div>
          <div class="dk-mrow2">
            <div class="dk-mfield">
              <label class="dk-mlabel"><feather-icon icon="ThermometerIcon" size="13" class="mr-1" />Temperatura</label>
              <b-form-input v-model="inteSelected.temperatura_gpt" type="number" placeholder="0.8" class="dk-minput" />
            </div>
            <div class="dk-mfield">
              <label class="dk-mlabel"><feather-icon icon="HashIcon" size="13" class="mr-1" />Max Tokens</label>
              <b-form-input v-model="inteSelected.max_tokens_gpt" type="number" placeholder="250" class="dk-minput" />
            </div>
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GitBranchIcon" size="13" class="mr-1" />Fluxo monitorado</label>
            <select v-model="inteSelected.id_chat" class="dk-mselect">
              <option value="">Selecione um fluxo...</option>
              <option v-for="fluxo in chatsExistents" :key="fluxo.id" :value="fluxo.id">{{ fluxo.name }}</option>
            </select>
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('edit-modal-gpt')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarEdicaoIntegracaoGPT(); $bvModal.hide('edit-modal-gpt')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar alterações
          </button>
        </div>
      </div>
    </b-modal>

    <!-- ── MODAL: Editar NoCRM ───────────────────────────────── -->
    <b-modal
      id="edit-modal-nocrm"
      centered
      hide-header
      hide-footer
      size="md"
    >
      <div class="dk-modal-inner">
        <div class="dk-modal-header">
          <div class="dk-modal-header-left">
            <img src="https://images.ctfassets.net/co0pvta7hzrh/6XPHfHOh41ZNDOUpfPqnMJ/6586c3e725805cc3a802b350d0767e16/463bb5c3f876-Favicon.svg" alt="NoCRM" class="dk-modal-logo">
            <div>
              <h5 class="dk-modal-title">Editar integração NoCRM</h5>
              <p class="dk-modal-sub">Atualize os dados de conexão</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="KeyIcon" size="13" class="mr-1" />API Token</label>
            <b-form-input v-model="inteSelected.api_token" type="text" placeholder="Digite o token" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GlobeIcon" size="13" class="mr-1" />Endereço de conta</label>
            <b-form-input v-model="inteSelected.context_gpt" type="text" placeholder="https://SUBDOMINIO.nocrm.io" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GitBranchIcon" size="13" class="mr-1" />Fluxo monitorado</label>
            <select v-model="inteSelected.id_chat" class="dk-mselect">
              <option value="">Selecione um fluxo...</option>
              <option v-for="fluxo in chatsExistents" :key="fluxo.id" :value="fluxo.id">{{ fluxo.name }}</option>
            </select>
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('edit-modal-nocrm')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarEdicaoIntegracaoGPT(); $bvModal.hide('edit-modal-nocrm')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar alterações
          </button>
        </div>
      </div>
    </b-modal>

    <!-- ── MODAL: iAqFaz ──────────────────────────────────────── -->
    <b-modal
      id="modal-iaqfaz"
      centered
      hide-header
      hide-footer
      size="lg"
    >
      <div class="dk-modal-inner">
        <div class="dk-modal-header dk-modal-header--iaqfaz">
          <div class="dk-modal-header-left">
            <div class="dk-modal-logo-icon dk-modal-logo-icon--iaqfaz">
              <feather-icon icon="ZapIcon" size="22" />
            </div>
            <div>
              <h5 class="dk-modal-title" style="color:#fff">Integração iAqFaz</h5>
              <p class="dk-modal-sub" style="color:rgba(255,255,255,0.7)">Automação via webhook</p>
            </div>
          </div>
          <button class="dk-modal-close-btn" @click="$bvModal.hide('modal-iaqfaz')">
            <feather-icon icon="XIcon" size="16" />
          </button>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="LinkIcon" size="13" class="mr-1" />URL do Webhook iAqFaz</label>
            <b-form-input v-model="iaqfazUrl" type="text" placeholder="https://app.iaqfaz.com.br/webhook/..." class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="BellIcon" size="13" class="mr-1" />Eventos</label>
            <div class="dk-event-checks">
              <label v-for="evt in webhookEvents" :key="evt.value" class="dk-event-check-item">
                <b-form-checkbox v-model="iaqfazEvents" :value="evt.value" />
                <div>
                  <span class="dk-event-check-name">{{ evt.label }}</span>
                  <span class="dk-event-check-desc">{{ evt.desc }}</span>
                </div>
              </label>
            </div>
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel"><feather-icon icon="GitBranchIcon" size="13" class="mr-1" />Fluxo monitorado</label>
            <select v-model="iaqfazChat" class="dk-mselect">
              <option value="">Todos os fluxos</option>
              <option v-for="fluxo in chatsExistents" :key="fluxo.id" :value="fluxo">{{ fluxo.name }}</option>
            </select>
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('modal-iaqfaz')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarIaqfaz(); $bvModal.hide('modal-iaqfaz')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar integração
          </button>
        </div>
      </div>
    </b-modal>

    <!-- ── MODAL: Ads Metrics (Wizard) ─────────────────────────── -->
    <b-modal
      id="modal-adsmetrics"
      centered
      hide-header
      hide-footer
      size="lg"
      body-class="p-0"
    >
      <div class="dk-adsmetrics-modal">
        <div class="dk-modal-header dk-modal-header--ads">
          <div class="dk-modal-header-left">
            <div class="dk-modal-logo-icon dk-modal-logo-icon--ads">
              <feather-icon icon="BarChart2Icon" size="22" />
            </div>
            <div>
              <h5 class="dk-modal-title" style="color:#fff">Integração Ads Metrics</h5>
              <p class="dk-modal-sub" style="color:rgba(255,255,255,0.7)">Rastreamento de conversões e métricas</p>
            </div>
          </div>
          <button class="dk-modal-close-btn" @click="$bvModal.hide('modal-adsmetrics')">
            <feather-icon icon="XIcon" size="16" />
          </button>
        </div>
        <div class="dk-adsmetrics-modal__body">
          <AdsMetricsWizard
            :existing-integration="adsmetricsIntegration"
            @saved="onAdsMetricsSaved"
            @close="$bvModal.hide('modal-adsmetrics')"
          />
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-meta-offline" centered hide-header hide-footer size="md">
      <div class="dk-modal-inner">
        <div class="dk-modal-header dk-modal-header--ads">
          <div class="dk-modal-header-left">
            <div class="dk-modal-logo-icon dk-modal-logo-icon--ads">
              <feather-icon icon="TargetIcon" size="20" />
            </div>
            <div>
              <h5 class="dk-modal-title" style="color:#fff">Meta Offline (CAPI)</h5>
              <p class="dk-modal-sub" style="color:rgba(255,255,255,0.7)">Configuração nativa de conversões</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel">Pixel ID</label>
            <b-form-input v-model="metaOffline.pixelId" type="text" placeholder="123456789012345" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel">Access Token</label>
            <b-form-input v-model="metaOffline.accessToken" type="text" placeholder="EAAB..." class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel">Test Event Code (opcional)</label>
            <b-form-input v-model="metaOffline.testEventCode" type="text" placeholder="TEST12345" class="dk-minput" />
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('modal-meta-offline')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarMetaOffline(); $bvModal.hide('modal-meta-offline')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar integração
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-google-offline" centered hide-header hide-footer size="md">
      <div class="dk-modal-inner">
        <div class="dk-modal-header dk-modal-header--ads">
          <div class="dk-modal-header-left">
            <div class="dk-modal-logo-icon dk-modal-logo-icon--ads">
              <feather-icon icon="TrendingUpIcon" size="20" />
            </div>
            <div>
              <h5 class="dk-modal-title" style="color:#fff">Google Ads Offline</h5>
              <p class="dk-modal-sub" style="color:rgba(255,255,255,0.7)">Conversões com click IDs</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel">Conversion ID</label>
            <b-form-input v-model="googleOffline.conversionId" type="text" placeholder="1234567890" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel">Conversion Label</label>
            <b-form-input v-model="googleOffline.conversionLabel" type="text" placeholder="AbCdEfGhIjKlMnOpQr" class="dk-minput" />
          </div>
          <div class="dk-mrow2">
            <div class="dk-mfield">
              <label class="dk-mlabel">Valor padrão</label>
              <b-form-input v-model="googleOffline.conversionValue" type="number" placeholder="297" class="dk-minput" />
            </div>
            <div class="dk-mfield">
              <label class="dk-mlabel">Moeda</label>
              <b-form-input v-model="googleOffline.currencyCode" type="text" placeholder="BRL" class="dk-minput" />
            </div>
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('modal-google-offline')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarGoogleOffline(); $bvModal.hide('modal-google-offline')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar integração
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-inbound-webhook" centered hide-header hide-footer size="md">
      <div class="dk-modal-inner">
        <div class="dk-modal-header dk-modal-header--ads">
          <div class="dk-modal-header-left">
            <div class="dk-modal-logo-icon dk-modal-logo-icon--ads">
              <feather-icon icon="ShieldIcon" size="20" />
            </div>
            <div>
              <h5 class="dk-modal-title" style="color:#fff">Webhook de Vendas (Inbound)</h5>
              <p class="dk-modal-sub" style="color:rgba(255,255,255,0.7)">Token de segurança para Kiwify</p>
            </div>
          </div>
        </div>
        <div class="dk-modal-body">
          <div class="dk-mfield">
            <label class="dk-mlabel">Token do Webhook</label>
            <b-form-input v-model="inboundWebhook.token" type="text" placeholder="token-seguro-123" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel">Integration Key (opcional)</label>
            <b-form-input v-model="inboundWebhook.integrationKey" type="text" placeholder="chave-venda-1" class="dk-minput" />
          </div>
          <div class="dk-mfield">
            <label class="dk-mlabel">URL para colar na Kiwify</label>
            <b-form-input :value="inboundWebhookUrl" type="text" readonly class="dk-minput" />
          </div>
        </div>
        <div class="dk-modal-footer">
          <button class="dk-mbtn-cancel" @click="$bvModal.hide('modal-inbound-webhook')">Cancelar</button>
          <button class="dk-mbtn-save" @click="salvarInboundWebhook(); $bvModal.hide('modal-inbound-webhook')">
            <feather-icon icon="SaveIcon" size="14" class="mr-50" />Salvar
          </button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import {
  VBTooltip,
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BCardFooter,
  BCardText,
  BButton,
  BImg,
  BTable,
  BProgress,
  BBadge,
  BFormInput,
  BFormCheckbox,
  BForm,
} from 'bootstrap-vue'
import { useApi } from '@/composables/useApi'
import url from 'url'
import Ripple from 'vue-ripple-directive'
import alert from 'element-ui/packages/alert'
import ModalConfirmation from '@/components/ModalConfirmation.vue'
import AdsMetricsWizard from '@/views/App/Integracoes/AdsMetricsWizard.vue'
import { RdStationService } from '../../../services/rdStation'

const api = useApi()
export default {
  components: {
    BRow,
    BFormInput,
    BFormCheckbox,
    BForm,
    BCol,
    BCard,
    BCardTitle,
    BCardFooter,
    BCardText,
    BButton,
    BImg,
    BTable,
    BProgress,
    BBadge,
    ModalConfirmation,
    AdsMetricsWizard,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  data() {
    return {
      url: '',
      apiToken: '',
      contexto: '',
      temperatura: '',
      max_tokens: '',
      chatsExistents: [],
      fluxoSelected: [],
      inteSelected: [],
      currentItemDelete: null,
      VUE_APP_HOST_TEMPLATE: process.env.VUE_APP_HOST_EMBED || process.env.VUE_APP_HOST_TEMPLATE,
      pipedrive: {},
      integrations: {},
      solidColor: [
        { bg: 'secondary', title: 'Secondary card title' },
      ],
      iaqfazUrl: '',
      iaqfazEvents: ['lead::finish'],
      iaqfazChat: '',
      metaOffline: {
        pixelId: '',
        accessToken: '',
        testEventCode: '',
      },
      googleOffline: {
        conversionId: '',
        conversionLabel: '',
        conversionValue: '',
        currencyCode: 'BRL',
      },
      inboundWebhook: {
        token: '',
        integrationKey: '',
      },
      adsmetricsIntegration: null,
      webhookEvents: [
        { value: 'lead::start', label: 'Lead iniciou conversa', desc: 'Visitante abriu o chat' },
        { value: 'lead::finish', label: 'Lead finalizou conversa', desc: 'Lead completou o fluxo' },
        { value: 'lead::email', label: 'Lead informou e-mail', desc: 'Lead preencheu o e-mail' },
        { value: 'lead::phone', label: 'Lead informou telefone', desc: 'Lead preencheu WhatsApp' },
        { value: 'lead::cta_click', label: 'Lead clicou no CTA', desc: 'Lead clicou na ação' },
        { value: 'user::signup', label: 'Lead se cadastrou grátis', desc: 'Cadastro no trial' },
        { value: 'payment::approved', label: 'Pagamento aprovado', desc: 'Pagamento via Kiwify' },
      ],
      fields: [
        { key: 'status', label: 'ATIVO' },
        // A virtual column that doesn't exist in items
        { key: 'modelo', label: 'MODELO' },

        // A column that needs custom formatting
        { key: 'indetificador', label: 'IDENTIFICADOR' },
        // A regular column
        { key: 'NOME', label: 'FLUXO' },
        // A regular column
        { key: 'eventos', label: 'EVENTOS' },
        // A virtual column made up from two fields
        { key: 'criado_em', label: 'CRIADO EM' },
        // A virtual column made up from two fields
        { key: 'delete', label: 'Ações' },
      ],

    }
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    rdStationIntegraions() {
      return this.$store.getters['AppChatbooster/getRdStationIntegration']
    },
    inboundWebhookUrl() {
      const origin = window.location.origin
      const token = encodeURIComponent(this.inboundWebhook.token || '')
      const integrationKey = encodeURIComponent(this.inboundWebhook.integrationKey || '')
      let url = `${origin}/api/dkbackend/webhooks/conversions/inbound/kiwify`
      const query = []
      if (token) query.push(`token=${token}`)
      if (integrationKey) query.push(`integration_key=${integrationKey}`)
      if (query.length) url += `?${query.join('&')}`
      return url
    },
  },
  mounted() {
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'Integration')
    this.getfluxos()
    this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
    this.loadAdsMetricsIntegration()
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    async changeStatusIntegration(id_integration, status_integration) {
      await api.put(`/ativaIntegracao/${id_integration}`, {
        status: status_integration,
      })
        .then(() => {
          this.$store.commit('AppChatbooster/SET_STATUS_INTEGRATION', {
            id: id_integration,
            status: status_integration,
          })
          this.$message({
            type: 'success',
            message: 'Alterado com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async getfluxos() {
      await api.get(`/chat/${this.userData.id}`)
        .then(data => {
          this.chatsExistents = (data.data || []).filter(c => c.status === 1)
        })
        .catch(err => console.error(err))
    },
    async salvarIntegracaoGPT() {
      await api.post('/Integracoes', {
        modelo: 'ChatGPT',
        fluxos: this.fluxoSelected.name,
        eventos: 'lead::finish',
        id_user: this.userData.id,
        id_chat: this.fluxoSelected.id,
        modelo_metadata: null,
        url: null,
        api_token: this.apiToken,
        contexto: this.contexto,
        max_tokens: this.max_tokens,
        temperatura: this.temperatura,
      })
        .then(() => {
          this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
          this.$message({
            type: 'success',
            message: 'Criado com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async salvarIntegracaoNoCRM() {
      await api.post('/Integracoes', {
        modelo: 'NoCRM',
        fluxos: this.fluxoSelected.name,
        eventos: 'lead::finish',
        id_user: this.userData.id,
        id_chat: this.fluxoSelected.id,
        modelo_metadata: null,
        url: this.url,
        api_token: this.apiToken,
      })
        .then(() => {
          this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
          this.$message({
            type: 'success',
            message: 'Criado com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async salvarIntegracao() {
      if (!this.url || !this.url.trim()) {
        this.$message({ type: 'error', message: 'Informe a URL do webhook' })
        return
      }
      if (!this.fluxoSelected || !this.fluxoSelected.id) {
        this.$message({ type: 'error', message: 'Selecione um fluxo' })
        return
      }
      await api.post('/Integracoes', {
        modelo: 'Webhook',
        fluxos: this.fluxoSelected.name,
        eventos: 'lead::finish',
        id_user: this.userData.id,
        id_chat: this.fluxoSelected.id,
        url: this.url.trim(),
      })
        .then(() => {
          this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
          this.$message({ type: 'success', message: 'Criado com sucesso' })
          this.url = ''
          this.fluxoSelected = []
        })
        .catch(err => {
          console.error(err)
          this.$message({ type: 'error', message: 'Erro ao salvar integração' })
        })
    },
    async getUrlAuth() {
      await api.get(`/getAuthUrl?id_user=${this.userData.id}`)
        .then(response => {
          this.integrations.link = response.data.authorizationUrl
          const popupIntegrations = window.open(this.integrations.link, '_blank', 'width=600,height=600')
          if (!popupIntegrations) return
          popupIntegrations.focus()
          clearInterval(this.interval)
          this.interval = setInterval(() => {
            try {
              if (popupIntegrations.closed) {
                clearInterval(this.interval)
                return
              }
              const href = popupIntegrations.location.href
              if (href && href.includes('?code')) {
                clearInterval(this.interval)
                const urlObj = url.parse(href, true)
                popupIntegrations.close()
                const { code, state } = urlObj.query
                this.$store.commit('AppChatboosterIntegration/SET_CODE_RDSTATION', code)
                this.$store.commit('AppChatboosterIntegration/SET_STATE_RDSTATION', state)
                this.$store.commit('AppChatbooster/SET_CURRENT_TAB_INTEGRATION', 'rdstation')
              }
            } catch (e) {
              // SecurityError: popup ainda está no domínio do OAuth provider (cross-origin)
              // Continua aguardando o redirect de volta para nossa aplicação
            }
          }, 1000)
        })
    },
    async handleDelete() {
      const rdStationService = new RdStationService()
      await rdStationService.deleteRdStation(this.currentItemDelete.id)
        .then(response => {
          this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    async getUrlAuthPipedrive() {
      this.$store.commit('AppChatbooster/RESET_INTEGRATION', {
        chatSelected: '',
        formPipedriveConfig: [
          { title: 'Nome do contato', id: 'name', value: '' },
          { title: 'Email do contato', id: 'email', value: '' },
          { title: 'Telefone do contato', id: 'phone', value: '' },
        ],
        inteSelected: {
          id: null,
          usuario_condicional_status: 0,
        },
        usuario_condicional: [],
      })
      await api.get(`/getAuthPipedrive?id_user=${this.userData.id}`)
        .then(response => {
          this.pipedrive.link = response.data.authorizationUrl
          const popupIntegrations = window.open(this.pipedrive.link, '_blank', 'width=600,height=600')
          if (!popupIntegrations) return
          popupIntegrations.focus()
          clearInterval(this.interval)
          this.interval = setInterval(() => {
            try {
              if (popupIntegrations.closed) {
                clearInterval(this.interval)
                return
              }
              const href = popupIntegrations.location.href
              if (href && href.includes('?code')) {
                clearInterval(this.interval)
                const urlObj = url.parse(href, true)
                popupIntegrations.close()
                const { code, state } = urlObj.query
                this.$store.commit('AppChatboosterIntegration/SET_CODE_PIPEDRIVER', code)
                this.$store.commit('AppChatboosterIntegration/SET_STATE_PIPEDRIVER', state)
                this.$store.commit('AppChatbooster/SET_CURRENT_TAB_INTEGRATION', 'pipedriver')
              }
            } catch (e) {
              // SecurityError: popup ainda está no domínio do OAuth provider (cross-origin)
            }
          }, 1000)
        })
    },

    async getUrlAuthActiveCampaign() {
      this.$store.commit('AppChatbooster/RESET_INTEGRATION', {
        chatSelected: '',
        formActivicampaignConfig: [
          { title: 'Nome do contato', id: 'firstName', value: '' },
          { title: 'Sobrenome', id: 'lastName', value: '' },
          { title: 'Email do contato', id: 'email', value: '' },
          { title: 'Telefone', id: 'phone', value: '' },
        ],
        inteSelected: {
          id: null,
        },
      })
      this.integrations.link = `${this.VUE_APP_HOST_TEMPLATE}/integrations/activecampaign`
      const popupIntegrations = window.open(this.integrations.link, '_blank', 'width=600,height=600')
      if (!popupIntegrations) return
      popupIntegrations.focus()
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        try {
          if (popupIntegrations.closed) {
            clearInterval(this.interval)
            return
          }
          const href = popupIntegrations.location.href
          if (href && href.includes('?status=closed')) {
            clearInterval(this.interval)
            popupIntegrations.close()
            this.$store.commit('AppChatbooster/SET_CURRENT_TAB_INTEGRATION', 'activecampaign')
          }
        } catch (e) {
          // SecurityError: popup ainda está no domínio externo (cross-origin)
        }
      }, 1000)
    },
    showModalDelete(item) {
      this.currentItemDelete = item
      this.$bvModal.show('modal-delete-integracao')
    },
    openModalWebhook() {
      this.$bvModal.show('modal-webhook')
    },
    openModalGPT() {
      this.$bvModal.show('modal-gpt')
    },
    openModalNoCRM() {
      this.$bvModal.show('modal-nocrm')
    },
    openModalIaqfaz() {
      this.$bvModal.show('modal-iaqfaz')
    },
    openModalAdsMetrics() {
      this.$bvModal.show('modal-adsmetrics')
    },
    openModalMetaOffline() {
      this.$bvModal.show('modal-meta-offline')
    },
    openModalGoogleOffline() {
      this.$bvModal.show('modal-google-offline')
    },
    openModalInboundWebhook() {
      const existing = this.rdStationIntegraions.find(i => i.modelo === 'InboundSalesWebhook')
      if (existing) {
        try {
          const meta = JSON.parse(existing.modelo_metadata || '{}')
          this.inboundWebhook.token = existing.api_token || meta.inboundToken || ''
          this.inboundWebhook.integrationKey = meta.integrationKey || ''
        } catch (_) {}
      }
      this.$bvModal.show('modal-inbound-webhook')
    },
    async loadAdsMetricsIntegration() {
      try {
        const { data } = await api.get(`/Integracoes?id_user=${this.userData.id}`)
        this.adsmetricsIntegration = data.find(i => i.modelo === 'AdsMetrics') || null
      } catch (e) { /* silent */ }
    },
    onAdsMetricsSaved() {
      this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
      this.loadAdsMetricsIntegration()
    },
    async salvarMetaOffline() {
      if (!this.metaOffline.pixelId || !this.metaOffline.accessToken) {
        this.$message({ type: 'error', message: 'Preencha Pixel ID e Access Token' })
        return
      }
      const payload = {
        modelo: 'MetaOffline',
        fluxos: 'Todos',
        eventos: 'payment::approved',
        id_user: this.userData.id,
        id_chat: null,
        modelo_metadata: JSON.stringify({
          pixelId: this.metaOffline.pixelId,
          accessToken: this.metaOffline.accessToken,
          testEventCode: this.metaOffline.testEventCode || undefined,
          actionSource: 'website',
          eventName: 'Purchase',
        }),
        status: 1,
      }
      try {
        const existing = this.rdStationIntegraions.find(i => i.modelo === 'MetaOffline')
        if (existing) await api.put(`/Integracoes/${existing.id}`, payload)
        else await api.post('/Integracoes', payload)
        this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
        this.$message({ type: 'success', message: 'Meta Offline configurado com sucesso' })
      } catch (err) {
        console.error(err)
        this.$message({ type: 'error', message: 'Erro ao salvar Meta Offline' })
      }
    },
    async salvarGoogleOffline() {
      if (!this.googleOffline.conversionId || !this.googleOffline.conversionLabel) {
        this.$message({ type: 'error', message: 'Preencha Conversion ID e Conversion Label' })
        return
      }
      const payload = {
        modelo: 'GoogleAdsOffline',
        fluxos: 'Todos',
        eventos: 'payment::approved',
        id_user: this.userData.id,
        id_chat: null,
        modelo_metadata: JSON.stringify({
          conversionId: this.googleOffline.conversionId,
          conversionLabel: this.googleOffline.conversionLabel,
          conversionValue: this.googleOffline.conversionValue || undefined,
          currencyCode: this.googleOffline.currencyCode || 'BRL',
        }),
        status: 1,
      }
      try {
        const existing = this.rdStationIntegraions.find(i => i.modelo === 'GoogleAdsOffline')
        if (existing) await api.put(`/Integracoes/${existing.id}`, payload)
        else await api.post('/Integracoes', payload)
        this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
        this.$message({ type: 'success', message: 'Google Ads Offline configurado com sucesso' })
      } catch (err) {
        console.error(err)
        this.$message({ type: 'error', message: 'Erro ao salvar Google Ads Offline' })
      }
    },
    async salvarInboundWebhook() {
      if (!this.inboundWebhook.token) {
        this.$message({ type: 'error', message: 'Informe o token do webhook' })
        return
      }
      const payload = {
        modelo: 'InboundSalesWebhook',
        fluxos: 'Todos',
        eventos: 'payment::approved',
        id_user: this.userData.id,
        id_chat: null,
        api_token: this.inboundWebhook.token,
        modelo_metadata: JSON.stringify({
          inboundToken: this.inboundWebhook.token,
          integrationKey: this.inboundWebhook.integrationKey || undefined,
          provider: 'kiwify',
        }),
        status: 1,
      }
      try {
        const existing = this.rdStationIntegraions.find(i => i.modelo === 'InboundSalesWebhook')
        if (existing) await api.put(`/Integracoes/${existing.id}`, payload)
        else await api.post('/Integracoes', payload)
        this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
        this.$message({ type: 'success', message: 'Webhook inbound configurado com sucesso' })
      } catch (err) {
        console.error(err)
        this.$message({ type: 'error', message: 'Erro ao salvar webhook inbound' })
      }
    },
    async salvarIaqfaz() {
      if (!this.iaqfazUrl || !this.iaqfazUrl.trim()) {
        this.$message({ type: 'error', message: 'Informe a URL do webhook' })
        return
      }
      await api.post('/Integracoes', {
        modelo: 'iAqFaz',
        fluxos: this.iaqfazChat ? this.iaqfazChat.name : 'Todos',
        eventos: this.iaqfazEvents.join(', '),
        id_user: this.userData.id,
        id_chat: this.iaqfazChat ? this.iaqfazChat.id : null,
        url: this.iaqfazUrl.trim(),
      })
        .then(() => {
          this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
          this.$message({ type: 'success', message: 'iAqFaz integrado com sucesso' })
          this.iaqfazUrl = ''
          this.iaqfazEvents = ['lead::finish']
          this.iaqfazChat = ''
        })
        .catch(err => {
          console.error(err)
          this.$message({ type: 'error', message: 'Erro ao salvar integração' })
        })
    },
    async enviarTesteIntegracao(item) {
      try {
        this.$message({ type: 'info', message: 'Enviando teste...' })
        const { data } = await api.post(`/webhook-test-integration/${item.id}`)
        if (data.success) {
          this.$message({ type: 'success', message: `Teste enviado! Evento: ${data.event}` })
        } else {
          this.$message({ type: 'error', message: `Falha: ${data.error || 'Erro desconhecido'}` })
        }
      } catch (err) {
        console.error(err)
        this.$message({ type: 'error', message: 'Erro ao enviar teste' })
      }
    },
    enviarTeste(integracao) {
      const userId = this.userData.id
      const chatId = integracao.id_chat || ''
      const pageUrl = window.location.origin
      const data = [
        {
          id_fluxo_ext: '799620f4-c0f3-4d37-bb1d-aebe873e441b',
          value: 'Lead Teste',
          label: 'nome',
          id_chat: chatId,
          id_user: userId,
          origem: pageUrl,
          page: pageUrl,
        },
        {
          id_fluxo_ext: '5668edb5-2294-45c3-b3f8-7ece19a6c28a',
          value: 'leadteste@exemplo.com.br',
          label: 'email',
          id_chat: chatId,
          id_user: userId,
          origem: pageUrl,
          page: pageUrl,
        },
        {
          id_fluxo_ext: '4c6025c1-9798-458f-9046-4c5b6ddee27d',
          value: '(11) 99999-9999',
          label: 'telefone',
          id_chat: chatId,
          id_user: userId,
          origem: pageUrl,
          page: pageUrl,
        },
      ]
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }

      fetch(`${integracao.url}`, options)
        .then(() => {
          this.$message({ type: 'success', message: 'Teste enviado com sucesso' })
        })
        .catch(err => {
          console.error(err)
          this.$message({ type: 'warning', message: 'Teste enviado (verifique CORS no destino se não recebeu)' })
        })
    },
    async editarIntegracao(item) {
      console.log(`[editarIntegracao] ITEM: ${item}`)
      if (item.modelo === 'Pipedrive') {
        this.$store.commit('AppChatbooster/SET_CURRENT_TAB_INTEGRATION', 'pipedriver')
        this.$store.commit('AppChatbooster/SET_CURRENT_INTEGRATION', item)
        await this.$store.dispatch('AppChatbooster/GET_CHAT_BY_ID', item)
      }
      if (item.modelo === 'RD Station') {
        this.$store.commit('AppChatbooster/SET_CURRENT_TAB_INTEGRATION', 'rdstation')
      }
      if (item.modelo === 'Activecampaign') {
        this.$store.commit('AppChatbooster/SET_CURRENT_TAB_INTEGRATION', 'activecampaign')
        this.$store.commit('AppChatbooster/SET_CURRENT_INTEGRATION_ACTIVE', item)
        await this.$store.dispatch('AppChatbooster/GET_CHAT_BY_ID', item)
      }
      if (item.modelo === 'Webhook') {
        this.inteSelected = item
        this.$bvModal.show('edit-modal-webhook')
      }
      if (item.modelo === 'ChatGPT') {
        this.inteSelected = item
        this.$bvModal.show('edit-modal-gpt')
      }
      if (item.modelo === 'iAqFaz') {
        this.iaqfazUrl = item.url || ''
        this.iaqfazEvents = item.eventos ? item.eventos.split(',').map(e => e.trim()) : ['lead::finish']
        this.iaqfazChat = ''
        this.inteSelected = item
        this.$bvModal.show('modal-iaqfaz')
      }
      if (item.modelo === 'AdsMetrics') {
        this.adsmetricsIntegration = item
        this.$bvModal.show('modal-adsmetrics')
      }
      if (item.modelo === 'MetaOffline') {
        try {
          const meta = JSON.parse(item.modelo_metadata || '{}')
          this.metaOffline.pixelId = meta.pixelId || ''
          this.metaOffline.accessToken = meta.accessToken || ''
          this.metaOffline.testEventCode = meta.testEventCode || ''
        } catch (_) {}
        this.$bvModal.show('modal-meta-offline')
      }
      if (item.modelo === 'GoogleAdsOffline') {
        try {
          const meta = JSON.parse(item.modelo_metadata || '{}')
          this.googleOffline.conversionId = meta.conversionId || ''
          this.googleOffline.conversionLabel = meta.conversionLabel || ''
          this.googleOffline.conversionValue = meta.conversionValue || ''
          this.googleOffline.currencyCode = meta.currencyCode || 'BRL'
        } catch (_) {}
        this.$bvModal.show('modal-google-offline')
      }
      if (item.modelo === 'InboundSalesWebhook') {
        try {
          const meta = JSON.parse(item.modelo_metadata || '{}')
          this.inboundWebhook.token = item.api_token || meta.inboundToken || ''
          this.inboundWebhook.integrationKey = meta.integrationKey || ''
        } catch (_) {}
        this.$bvModal.show('modal-inbound-webhook')
      }
      console.log(item)
    },
    async salvarEdicaoIntegracaoGPT() {
      await api.put(`/Integracoes/${this.inteSelected.id}`, {
        modelo: 'ChatGPT',
        fluxos: this.inteSelected.name,
        eventos: 'lead::finish',
        id_user: this.userData.id,
        id_chat: this.inteSelected.id_chat,
        modelo_metadata: null,
        url: null,
        api_token: this.inteSelected.api_token,
        contexto: this.inteSelected.context_gpt,
        max_tokens: this.inteSelected.max_tokens_gpt,
        temperatura: this.inteSelected.temperatura_gpt,
      })
        .then(() => {
          this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
          this.$message({
            type: 'success',
            message: 'Atualizado com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async salvarEdicaoIntegracao() {
      if (!this.inteSelected.url || !this.inteSelected.url.trim()) {
        this.$message({ type: 'error', message: 'Informe a URL do webhook' })
        return
      }
      if (!this.inteSelected.id_chat) {
        this.$message({ type: 'error', message: 'Selecione um fluxo' })
        return
      }
      const fluxoNome = (this.chatsExistents.find(c => c.id === this.inteSelected.id_chat) || {}).name
        || this.inteSelected.fluxos
        || ''
      await api.put(`/Integracoes/${this.inteSelected.id}`, {
        modelo: 'Webhook',
        fluxos: fluxoNome,
        eventos: 'lead::finish',
        id_user: this.userData.id,
        id_chat: this.inteSelected.id_chat,
        modelo_metadata: '',
        url: this.inteSelected.url.trim(),
      })
        .then(() => {
          this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
          this.$message({ type: 'success', message: 'Atualizado com sucesso' })
        })
        .catch(err => {
          console.error(err)
          this.$message({ type: 'error', message: 'Erro ao atualizar integração' })
        })
    },
  },
}
</script>

<style lang="scss">
/* ─── Variáveis DK ───────────────────────────── */
$navy:   #0D3349;
$orange: #E86A10;
$gold:   #F5B935;
$border: #DDE3EA;
$bg:     #F4F6F9;

/* ── BootstrapVue modal dark override ─────────── */
#edit-modal-webhook,
#edit-modal-gpt,
#edit-modal-nocrm,
#modal-webhook,
#modal-gpt,
#modal-nocrm,
#modal-iaqfaz-result,
#modal-ads-metrics {
  .modal-content {
    background: #111827 !important;
    border: 1px solid rgba(255,255,255,0.1) !important;
  }
  .modal-body { padding: 0 !important; background: transparent !important; }
}

/* ─── Wrap geral ─────────────────────────────── */
.dk-integracoes-wrap {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ─── Card genérico ──────────────────────────── */
.dk-int-card {
  background: var(--dk-bg-card, #fff);
  border-radius: 12px;
  border: 1px solid $border;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(13, 51, 73, 0.06);
}

/* ─── Header do card ─────────────────────────── */
.dk-int-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 22px;
  background: $navy;
}

.dk-int-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dk-int-header-icon { color: $gold; }

.dk-int-header-title {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.dk-int-count-badge {
  background: $orange;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: 20px;
}

/* ─── Body do card de plataformas ────────────── */
.dk-int-card-body {
  padding: 22px 24px;
}

.dk-section-desc {
  font-size: 13px;
  color: var(--dk-text-secondary, #6b7a8d);
  margin-bottom: 20px;
}

/* ─── Empty state ────────────────────────────── */
.dk-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 24px;
  text-align: center;
}

.dk-empty-icon { color: var(--dk-text-faint, #c8d0da); margin-bottom: 12px; }
.dk-empty-text { font-size: 15px; font-weight: 600; color: $navy; margin: 0; }
.dk-empty-sub  { font-size: 13px; color: var(--dk-text-muted, #8a98a8); margin: 4px 0 0; }

/* ─── Tabela personalizada ───────────────────── */
.dk-table-wrap { overflow-x: auto; }

.dk-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  thead tr {
    background: $bg;
    border-bottom: 2px solid $border;
  }

  th {
    padding: 11px 16px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--dk-text-secondary, #6b7a8d);
    white-space: nowrap;
  }

  td {
    padding: 13px 16px;
    vertical-align: middle;
    border-bottom: 1px solid $border;
    color: var(--dk-text-primary, #3d4a5c);
  }

  .dk-table-row:last-child td { border-bottom: none; }

  .dk-table-row:hover td { background: var(--dk-bg-page, #f8fafc); }
}

/* ─── Badges de modelo ───────────────────────── */
.dk-model-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  background: #e8eef4;
  color: $navy;

  &.dk-model-activecampaign { background: #fff0e0; color: #c05900; }
  &.dk-model-pipedrive       { background: #e0f7ea; color: #1a7a45; }
  &.dk-model-webhook         { background: #ede8f8; color: #6b3fa0; }
  &.dk-model-chatgpt         { background: #e6f4f1; color: #1a7a6b; }
  &.dk-model-rdstation       { background: #fce8e8; color: #b52020; }
  &.dk-model-nocrm           { background: #e8f1fc; color: #1a4a8a; }
  &.dk-model-metaoffline     { background: #e8edff; color: #3147c0; }
  &.dk-model-googleadsoffline { background: #e6f7ed; color: #1f7a45; }
}

/* ─── Células da tabela ──────────────────────── */
.dk-identifier {
  font-family: monospace;
  font-size: 11px;
  color: var(--dk-text-muted, #8a98a8);
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.dk-flow-name {
  font-weight: 600;
  color: $navy;
  font-size: 13px;
}

.dk-event-badge {
  font-size: 11px;
  background: var(--dk-bg-inset, #f0f2f5);
  padding: 2px 8px;
  border-radius: 4px;
  color: var(--dk-text-secondary, #6b7a8d);
  font-family: monospace;
}

.dk-date {
  font-size: 12px;
  color: var(--dk-text-muted, #8a98a8);
  white-space: nowrap;
}

/* ─── Botões de ação ─────────────────────────── */
.dk-actions {
  display: flex;
  gap: 6px;
  align-items: center;
}

.dk-action-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: all .15s;
  background: transparent;

  &.dk-action-delete {
    color: #c12b2b;
    border-color: var(--dk-border, #f5c6c6);
    background: #fef2f2;
    &:hover { background: #c12b2b; color: #fff; border-color: #c12b2b; }
  }

  &.dk-action-edit {
    color: $navy;
    border-color: $border;
    background: $bg;
    &:hover { background: $navy; color: #fff; border-color: $navy; }
  }

  &.dk-action-test {
    color: darken($gold, 20%);
    border-color: lighten($gold, 20%);
    background: lighten($gold, 38%);
    &:hover { background: $gold; color: #fff; border-color: $gold; }
  }
}

/* ─── Grid de plataformas ────────────────────── */
.dk-platforms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.dk-platform-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border: 1.5px solid $border;
  border-radius: 10px;
  background: var(--dk-bg-card-hover, #fafbfc);
  transition: border-color .18s, box-shadow .18s;

  &:hover {
    border-color: $orange;
    box-shadow: 0 2px 12px rgba(232, 106, 16, 0.12);
  }
}

.dk-platform-logo-wrap {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--dk-bg-card, #fff);
  border-radius: 10px;
  border: 1px solid $border;
  overflow: hidden;
}

.dk-platform-logo {
  max-width: 42px;
  max-height: 42px;
  object-fit: contain;
}

.dk-platform-info {
  flex: 1;
  min-width: 0;
}

.dk-platform-name {
  font-size: 14px;
  font-weight: 700;
  color: $navy;
  margin: 0 0 3px;
}

.dk-platform-desc {
  font-size: 11px;
  color: var(--dk-text-muted, #8a98a8);
  margin: 0;
  line-height: 1.4;
}

.dk-platform-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  background: $navy;
  background-image: none !important;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background .15s;

  &:hover { background: darken($navy, 6%); }
}

/* ─── Modais — design compacto e clean ─────────── */
::v-deep .modal-content {
  border-radius: 12px !important;
  overflow: hidden;
  border: none !important;
  box-shadow: 0 12px 40px rgba(0,0,0,0.14) !important;
}
::v-deep .modal-body { padding: 0 !important; }

.dk-modal-inner { border-radius: 12px; overflow: hidden; }

.dk-modal-header {
  background: $navy;
  padding: 14px 18px;
  display: flex;
  align-items: center;
}
.dk-modal-header-left { display: flex; align-items: center; gap: 10px; }

.dk-modal-logo {
  width: 32px; height: 32px; object-fit: contain;
  background: rgba(#fff, 0.12); border-radius: 7px; padding: 3px;
}
.dk-modal-title { font-size: 13px; font-weight: 700; color: #fff; margin: 0; }
.dk-modal-sub { font-size: 11px; color: rgba(255,255,255,.55); margin: 1px 0 0; }

.dk-modal-body {
  padding: 16px 18px 8px;
  display: flex; flex-direction: column; gap: 12px;
  background: #111827;
}

.dk-mfield { display: flex; flex-direction: column; gap: 4px; }
.dk-mrow2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }

.dk-mlabel {
  display: flex; align-items: center; gap: 3px;
  font-size: 11px; font-weight: 600; color: #94a3b8;
  text-transform: uppercase; letter-spacing: 0.03em; margin: 0;
}

.dk-minput {
  height: 36px !important;
  border: 1px solid rgba(255,255,255,0.12) !important;
  border-radius: 7px !important;
  font-size: 12.5px !important;
  padding: 0 10px !important;
  background: rgba(255,255,255,0.06) !important;
  color: #e2e8f0 !important;
  transition: border-color .15s, box-shadow .15s !important;
  &:focus {
    border-color: $orange !important;
    box-shadow: 0 0 0 2px rgba($orange, 0.15) !important;
    background: rgba(255,255,255,0.08) !important;
  }
}

.dk-mselect {
  width: 100%; height: 36px; padding: 0 10px;
  border: 1px solid rgba(255,255,255,0.12); border-radius: 7px;
  font-size: 12.5px; color: #e2e8f0;
  background: rgba(255,255,255,0.06); outline: none; cursor: pointer;
  &:focus { border-color: $orange; box-shadow: 0 0 0 2px rgba($orange, 0.15); }
  option { background: #1e2a3a; color: #e2e8f0; }
}

.dk-modal-footer {
  display: flex; justify-content: flex-end; gap: 8px;
  padding: 12px 18px 16px;
  background: #111827;
  border-top: 1px solid rgba(255,255,255,0.08);
}

.dk-mbtn-cancel {
  background: rgba(255,255,255,0.08); background-image: none !important;
  color: #94a3b8; border: 1px solid rgba(255,255,255,0.12); border-radius: 7px;
  padding: 7px 16px; font-size: 12px; font-weight: 600;
  cursor: pointer; transition: background .15s;
  &:hover { background: rgba(255,255,255,0.13); color: #e2e8f0; }
}

.dk-mbtn-save {
  display: inline-flex; align-items: center;
  background: $orange !important; background-image: none !important;
  color: #fff !important; border: none !important;
  border-radius: 7px; padding: 7px 18px;
  font-size: 12px; font-weight: 700;
  cursor: pointer; transition: all .15s;
  box-shadow: 0 2px 8px rgba($orange, 0.25);
  &:hover { background: darken($orange, 6%) !important; transform: translateY(-0.5px); }
}

/* ── iAqFaz & Ads Metrics platform cards ────────── */
.dk-platform-card--highlight {
  border: 1.5px solid rgba($orange, 0.12);
}
.dk-platform-logo-wrap--iaqfaz {
  background: rgba(#7c3aed, 0.08) !important;
  color: #7c3aed !important;
  display: flex; align-items: center; justify-content: center;
}
.dk-platform-logo-wrap--adsmetrics {
  background: rgba(#2563eb, 0.08) !important;
  color: #2563eb !important;
  display: flex; align-items: center; justify-content: center;
}
.dk-platform-btn--ads {
  background: #2563eb !important; color: #fff !important;
  &:hover { background: darken(#2563eb, 8%) !important; }
}

/* ── Modal header variants ────────── */
.dk-modal-header--iaqfaz { background: #7c3aed; }
.dk-modal-header--ads { background: #1e40af; }
.dk-modal-logo-icon {
  width: 32px; height: 32px; border-radius: 7px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  background: rgba(#fff, 0.15); color: #fff;
}
.dk-modal-close-btn {
  background: rgba(#fff, 0.1); border: none; border-radius: 6px;
  color: rgba(#fff, 0.7); width: 26px; height: 26px;
  display: flex; align-items: center; justify-content: center; cursor: pointer;
  transition: background 0.15s; margin-left: auto;
  &:hover { background: rgba(#fff, 0.2); color: #fff; }
}

/* ── Event checkboxes in modals ────────── */
.dk-event-checks { display: flex; flex-direction: column; gap: 4px; }
.dk-event-check-item {
  display: flex; align-items: center; gap: 8px;
  padding: 7px 10px; margin: 0;
  background: #fafbfc; border: 1px solid $border;
  border-radius: 7px; cursor: pointer;
  transition: border-color 0.15s;
  &:hover { border-color: rgba($orange, 0.3); }
}
.dk-event-check-name { display: block; font-size: 12px; font-weight: 600; color: $navy; }
.dk-event-check-desc { display: block; font-size: 10.5px; color: #9ca5b0; }

/* ── Ads Metrics modal body ────────── */
.dk-adsmetrics-modal { border-radius: 12px; overflow: hidden; }
.dk-adsmetrics-modal__body { padding: 16px 18px 18px; }
</style>
